import { render, staticRenderFns } from "./CUStaticPageForm.vue?vue&type=template&id=6600c0fb&scoped=true"
import script from "./CUStaticPageForm.vue?vue&type=script&lang=js"
export * from "./CUStaticPageForm.vue?vue&type=script&lang=js"
import style0 from "./CUStaticPageForm.vue?vue&type=style&index=0&id=6600c0fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600c0fb",
  null
  
)

export default component.exports